import { Column, CreateDateColumn, PrimaryGeneratedColumn } from 'typeorm';

import { ApiProperty } from '../../codegen';
import {
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
} from '../../validators';

import { ETransactionType } from './transaction.enums';
import {
  BillingTransactionData,
  CryptoWithdrawTransactionData,
  DailyRewardTransactionData,
  MatchPayoutTransactionData,
  MatchRefundTransactionData,
  MatchStakeTransactionData,
  PromoTransactionData,
  TaskTransactionData,
} from './transaction.types';

export class Transaction {
  @ApiProperty()
  @IsNumber()
  @PrimaryGeneratedColumn()
  id: number;

  @CreateDateColumn({ type: 'timestamptz' })
  createdAt!: Date;

  @Column({ type: 'int', nullable: false })
  accountId: number;

  @ApiProperty()
  @IsString()
  @IsOptional()
  @Column({ type: 'text', nullable: true, unique: true })
  referenceKey?: string | null;

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  coins: number;

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  coinsPaid: number;

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  coinsPartner: number;

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  coinsSubscription: number;

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  coinsPromo: number;

  @ApiProperty()
  @IsEnum(ETransactionType)
  @Column({
    type: 'int',
    nullable: false,
    enum: ETransactionType,
  })
  transactionType: ETransactionType;

  @ApiProperty()
  @Column({ type: 'jsonb', nullable: false, default: {} })
  @IsObject({ groups: ['error'] })
  data:
    | TaskTransactionData
    | BillingTransactionData
    | PromoTransactionData
    | DailyRewardTransactionData
    | MatchStakeTransactionData
    | MatchPayoutTransactionData
    | MatchRefundTransactionData
    | CryptoWithdrawTransactionData;
}
